/* eslint-disable react/prop-types */
import React from 'react';

import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {arrayMove} from 'react-sortable-hoc';

import * as modalActions from '@/actions/modalActions';
import * as setupActions from '@/actions/setupActions';
import {SetCustomOperationRepeatedValue, SetCustomOperationRepeatValue} from '@/actions/setupActions';
import {saveManualProfile} from '@/businesses/manualProfileBusiness';
import * as APPDATA from '@/constants/pcConstAppData';
import {createNewJsonObject} from '@/libs/appHelper';
import {consoleDebug} from '@/libs/consoleHelper';

import {
  findSequenceIndex,
  findMaxValueByRepeatType,
  findMaxDigitValueByRepeatType,
  findIncrementValueByRepeatType,
} from './business/commonFunction';
import {
  AddSequence,
  DeleteSelectedSequence,
  ChangeSequenceState,
  ChangePressureType,
  ChangeSequenceType,
  ChangeRepeatMode,
  ChangeSequenceTempRepeat,
} from './business/sequenceContent';
import {TopContentRunners, SortableList} from './components/ContentRunners';
import {GenerateSequenceSelector} from './components/SequenceTypeUpdate';
import {SEQUENCE_TYPE, RUN_TIME_MODE, MAXIMUM_SEQUENCE} from './constant/sequenceContentConstants';
// eslint-disable-next-line import/no-cycle
import {VIEW_MODE} from './ManualProfile';

@connect((store) => ({
  isManualProfileRunning: store.setupStore.isManualProfileRunning,
  defaultSequenceTemplate: store.setupStore.defaultSequenceTemplate,
  CustomOperation: store.setupStore.CustomOperation,
  defaultConfigAdvSetupParams: store.setupStore.defaultConfigAdvSetupParams,
}))
class SequenceDesigner extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      operations: props.operations,
    };
  }

  componentDidMount() {
    const {CustomOperation, dispatch} = this.props;
    const operations = [...CustomOperation.Operations];
    if (operations.length > 0) {
      let updateState = false;

      const _operations = createNewJsonObject(operations);

      _operations.forEach((element) => {
        if (element.TempRepeat === undefined) {
          element.TempRepeat = element.Repeat;
          updateState = true;
        }
      });

      if (updateState) {
        this.setState({
          operations: _operations,
        });
        dispatch(setupActions.UpdateOperationList(_operations));
      }
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.operations !== prevState.operations) {
      return {operations: nextProps.operations};
    }
    return null;
  }

  // local common
  /**
   * @param {*} newOperations
   */
  updateOperations = (newOperations) => {
    const {onChangeOperations} = this.props;

    this.setState({
      operations: newOperations,
    });
    onChangeOperations(newOperations);
  };
  // end local common

  actionAddSequence = async () => {
    const {defaultSequenceTemplate, defaulthPrimeParam} = this.props;
    const {operations} = this.state;

    if (operations.length >= MAXIMUM_SEQUENCE) {
      console.warn('maximum sequence reach');
      return;
    }

    const newOperations = AddSequence(operations, defaultSequenceTemplate);

    newOperations[newOperations.length - 1].TempRepeat = defaulthPrimeParam;
    this.updateOperations(newOperations);
  };

  // eslint-disable-next-line class-methods-use-this
  actionOpenSequenceFile = () => {
    window.location.href = APPDATA.MANUAL_PROFILE_EXPLORER_ADDRESS;
  };

  actionSaveSequenceFile = (saveAs) => {
    const {dispatch} = this.props;

    dispatch(
      modalActions.showKeyboard({
        keyboardTitle: saveAs ? APPDATA.SAVE_MANUAL_PROFILE_AS : APPDATA.SAVE_MANUAL_PROFILE,
        keyboardCallBack: this.onChangeAdvSetupName,
        keyboardPlaceholder: APPDATA.SAVE_MANUAL_PROFILE_PLACEHOLDER,
        overwriteFirstInput: true,
        max: 100,
      }),
    );
  };

  onChangeAdvSetupName = (e) => {
    const {dispatch} = this.props;
    const stringRegex = /[ `!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?~]/;

    if (stringRegex.test(e.value)) {
      dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: APPDATA.MESSAGES.MANUAL_PROFILE.FIELD_ERROR.FILE_NAME_CONTAIN_SYMBOLS,
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
        }),
      );
    } else if (e.value === '' || e.value === undefined) {
      dispatch(
        setupActions.showAlert({
          alertShow: true,
          alertText: APPDATA.MESSAGES.MANUAL_PROFILE.FIELD_ERROR.FILE_NAME_CANNOT_BE_EMPTY,
          alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
        }),
      );
    } else {
      const name = e.value;
      this.saveSequenceToBackend(name, true);
    }
  };

  onClickSaveSequence = () => {
    const {CustomOperation, dispatch} = this.props;

    const popUpButton = [
      {
        id: APPDATA.CANCEL,
        isPrimaryButton: false,
        onClick: this.onClickPopUp,
        label: APPDATA.CANCEL,
        className: 'tertiaryButton float-left',
      },
    ];

    if (CustomOperation.FileName) {
      popUpButton.push({
        id: APPDATA.SAVE_AS,
        isPrimaryButton: CustomOperation.IsPreloaded,
        onClick: this.onClickPopUp,
        label: APPDATA.SAVE_AS,
      });
    }

    if (!CustomOperation.IsPreloaded) {
      popUpButton.push({
        id: APPDATA.SAVE,
        isPrimaryButton: true,
        onClick: this.onClickPopUp,
        label: APPDATA.SAVE,
      });
    }

    const maxFileNameLeght = 10;
    let fileName = CustomOperation.FileName;

    if (CustomOperation.FileName !== null)
      if (fileName.length > maxFileNameLeght) fileName = `${fileName.substring(0, maxFileNameLeght)}...`;

    const popupQuestion =
      CustomOperation.FileName === null
        ? APPDATA.SAVE_MANUAL_PROFILE_QUESTION
        : APPDATA.SAVE_AS_MANUAL_PROFILE_QUESTION.replace('<manualProfile name>', fileName);

    dispatch(
      modalActions.showPopUp({
        popUpTitle: APPDATA.SAVE_MANUAL_PROFILE,
        popUpQuestion: popupQuestion,
        popUpButton,
      }),
    );
  };

  onClickPopUp = (e) => {
    const {CustomOperation, dispatch} = this.props;

    dispatch(modalActions.hidePopUp());

    switch (e.currentTarget.id) {
      case APPDATA.SAVE_AS:
        this.actionSaveSequenceFile(true);
        break;
      case APPDATA.SAVE:
        if (CustomOperation.FileName === null) this.actionSaveSequenceFile(false);
        else this.saveSequenceToBackend(CustomOperation.FileName, false);
        break;
      case APPDATA.CANCEL:
        break;
      default:
        break;
    }
  };

  saveSequenceToBackend = async (fileName, saveAs) => {
    const {dispatch} = this.props;
    const {operations} = this.state;

    dispatch(saveManualProfile(fileName, saveAs, operations));
  };

  clearSequence = () => {
    const {dispatch} = this.props;

    const newOperations = []; // AddSequence([])
    const newRepeatOperations = {
      Repeat: 1,
      Repeated: 0,
    };

    dispatch(SetCustomOperationRepeatValue(newRepeatOperations.Repeat));
    dispatch(SetCustomOperationRepeatedValue(newRepeatOperations.Repeated));
    this.updateOperations(newOperations);
  };

  // sortable methood
  sortOperations = (parameter) => {
    const {operations} = this.state;

    const newOperations = arrayMove(operations, parameter.oldIndex, parameter.newIndex);

    this.updateOperations(newOperations);
  };

  removeSequence = (removeOrderId) => {
    const {operations} = this.state;

    const indexDeleted = findSequenceIndex(operations, removeOrderId);
    const newOperations = DeleteSelectedSequence(indexDeleted, operations);

    this.updateOperations(newOperations);
  };

  updateSequenceState = (selectedSequenceId, newState) => {
    const {operations} = this.state;

    const indexUpdated = findSequenceIndex(operations, selectedSequenceId);
    const newOperations = ChangeSequenceState(indexUpdated, newState, operations);

    this.updateOperations(newOperations);
  };

  updatePressureType = (selectedSequenceId, newState) => {
    const {operations} = this.state;

    const indexUpdated = findSequenceIndex(operations, selectedSequenceId);
    const newOperations = ChangePressureType(indexUpdated, newState, operations);

    this.updateOperations(newOperations);
  };

  sequenceChange = (selectedSequenceId, oldSequenceType) => {
    const {dispatch} = this.props;

    const popUpButton = [
      {
        id: APPDATA.OK,
        isPrimaryButton: true,
        onClick: this.setChangeSequenceType,
        label: APPDATA.OK,
      },
    ];

    const sequenceSelector = GenerateSequenceSelector(
      SEQUENCE_TYPE,
      selectedSequenceId,
      oldSequenceType,
      this.onChangeSequenceType,
      'cycle-dropdown-selection',
    );

    dispatch(
      modalActions.showPopUp({
        popUpTitle: 'Select Cycle',
        popUpText: sequenceSelector,

        popUpButton,
      }),
    );
  };

  onChangeSequenceType = (newSequenceType, selectedSequenceId, oldSequenceType) => {
    this._tempNewChangeOfSequence = {
      newSequenceType,
      selectedSequenceId,
      oldSequenceType,
    };
  };

  setChangeSequenceType = async () => {
    const {dispatch, defaultConfigAdvSetupParams} = this.props;
    const {operations} = this.state;

    const {selectedSequenceId} = this._tempNewChangeOfSequence;
    const newState = this._tempNewChangeOfSequence.newSequenceType;
    const indexUpdated = findSequenceIndex(operations, selectedSequenceId);
    const newOperations = await ChangeSequenceType(
      indexUpdated,
      newState,
      operations,
      defaultConfigAdvSetupParams.ConfigAdvSetup,
    );

    dispatch(modalActions.hidePopUp());
    this.updateOperations(newOperations);
  };

  updateTotalRepeat = (selectedSequenceId) => {
    const {dispatch} = this.props;
    const {operations} = this.state;

    const indexUpdated = findSequenceIndex(operations, selectedSequenceId);
    const currentOperation = operations[indexUpdated];
    const maxValue = findMaxValueByRepeatType(currentOperation.RepeatType);
    const incrementValue = findIncrementValueByRepeatType(currentOperation.RepeatType);
    const maxDigitAfterDecimal = findMaxDigitValueByRepeatType(currentOperation.RepeatType);

    dispatch(
      modalActions.showModal({
        modalHeader:
          currentOperation.RepeatType === RUN_TIME_MODE.TIMES.VALUE
            ? RUN_TIME_MODE.TIMES.NUMPAD_TITLE
            : RUN_TIME_MODE.MINUTES.NUMPAD_TITLE,
        value: currentOperation.TempRepeat,
        callback: this.setTotalRepeat,
        maxValue,
        minValue: currentOperation.RepeatType === RUN_TIME_MODE.TIMES.VALUE ? 1 : 0.01,
        maxDigitAfterDecimal,
        incrementValue,
        unit: 'x',
      }),
    );

    this._tempTotalRepeat = {
      indexUpdated,
    };
  };

  setTotalRepeat = (e) => {
    const {operations} = this.state;

    const {indexUpdated} = this._tempTotalRepeat;
    const newValue = e.value;
    const newOperations = ChangeSequenceTempRepeat(indexUpdated, newValue, operations);

    this.updateOperations(newOperations);
  };

  onClickSequenceConfig = (selectedSequenceId) => {
    const {changeViewMode} = this.props;

    const viewProps = {
      viewMode: VIEW_MODE.CONFIGURATION,
      operationId: selectedSequenceId,
    };

    changeViewMode(viewProps);
  };

  onChangeRepeatMode = (selectedSequenceId, newValue) => {
    const {operations} = this.state;

    const indexUpdated = findSequenceIndex(operations, selectedSequenceId);
    const newOperations = ChangeRepeatMode(indexUpdated, newValue, operations);

    if (newValue === 1) {
      // const test = Math.round(newOperations[indexUpdated].TempRepeat);
      newOperations[indexUpdated].TempRepeat = Math.round(newOperations[indexUpdated].TempRepeat);
    }

    this.updateOperations(newOperations);
  };

  onClickRepeatAll = () => {
    const {dispatch, repeatAll, onChangeRepeatAll} = this.props;

    dispatch(
      modalActions.showModal({
        modalHeader: 'Repeat All',
        value: repeatAll,
        callback: onChangeRepeatAll,
        maxValue: 1000,
        minValue: 1,
        maxDigitAfterDecimal: 0,
        unit: 'x',
      }),
    );
  };

  // end sortable method
  render() {
    const {repeatAll, isManualProfileRunning, operations, CustomOperation} = this.props;

    return (
      <>
        <TopContentRunners
          addSequence={this.actionAddSequence}
          openSequenceFile={this.actionOpenSequenceFile}
          saveSequenceFile={this.onClickSaveSequence}
          clearSequence={this.clearSequence}
          onClickRepeatAll={this.onClickRepeatAll}
          repeatAll={repeatAll}
          isSequenceDesignerRunning={isManualProfileRunning}
          isMaximumSequence={operations.length >= MAXIMUM_SEQUENCE}
          emptyOperations={operations.length === 0}
          operationChanged={CustomOperation.ContentChanged}
          isPreloaded={CustomOperation.IsPreloaded}
        />
        <SortableList
          useDragHandle
          lockAxis="y"
          transitionDuration={500}
          operations={operations}
          onSortEnd={this.sortOperations}
          removeSequence={this.removeSequence}
          updateSequenceState={this.updateSequenceState}
          updatePressureType={this.updatePressureType}
          updateTotalRepeat={this.updateTotalRepeat}
          sequenceChange={this.sequenceChange}
          isSequenceDesignerRunning={isManualProfileRunning}
          onClickSequenceConfig={this.onClickSequenceConfig}
          onChangeRepeatMode={this.onChangeRepeatMode}
        />
      </>
    );
  }
}
// TODO: need to define the props derived structure
SequenceDesigner.propTypes = {
  onChangeOperations: PropTypes.func,
  changeViewMode: PropTypes.func,
  onChangeRepeatAll: PropTypes.func,
};

SequenceDesigner.defaultProps = {
  /**
   * @param {*} response
   * @returns
   */
  onChangeOperations: (response) => consoleDebug('Sample output', response),
  /**
   * @param {*} response
   * @returns
   */
  changeViewMode: (response) => consoleDebug('Sample output', response),
  /**
   * @param {*} response
   * @returns
   */
  onChangeRepeatAll: (response) => consoleDebug('Sample output', response),
};
export default SequenceDesigner;
